var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8 7H4.2V8.4H2.8V7ZM12.6 2.8V12.6C12.6 12.9713 12.4525 13.3274 12.19 13.5899C11.9274 13.8525 11.5713 14 11.2 14H1.4C0.623 14 0 13.37 0 12.6V2.8C0 2.4287 0.1475 2.0726 0.41005 1.81005C0.672601 1.5475 1.0287 1.4 1.4 1.4H2.1V0H3.5V1.4H9.1V0H10.5V1.4H11.2C11.5713 1.4 11.9274 1.5475 12.19 1.81005C12.4525 2.0726 12.6 2.4287 12.6 2.8ZM1.4 4.2H11.2V2.8H1.4V4.2ZM11.2 12.6V5.6H1.4V12.6H11.2ZM8.4 8.4V7H9.8V8.4H8.4ZM5.6 8.4V7H7V8.4H5.6ZM2.8 9.8H4.2V11.2H2.8V9.8ZM8.4 11.2V9.8H9.8V11.2H8.4ZM5.6 11.2V9.8H7V11.2H5.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.84c7d48d.svg";
export { ForwardRef as ReactComponent };